import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import sales from "../../../Data/sales.json";
import customers from "../../../Data/customers.json";
import toast from "react-hot-toast";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_sales_reports } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

const SalesReportDashboard = () => {
  let componentRef = useRef();
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const headers = {
    name: "Invoices",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Price (Low-High)" },
          { value: 1, label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "customer",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Customer",
        api: "get-all-customers",
        value: null,
        options: null,
      },
      // {
      //   type: "filter",
      //   name: "branch",
      //   allowClear: true,
      //   showSearch: true,
      //   filterOption: false,
      //   placeholder: "Branch",
      //   api: "get-all-branches",
      //   value: null,
      //   options: null,
      // },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: new Date(),
          end: new Date(),
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
      };

      const products = await get_sales_reports(data);
      if (products?.status) {
        setBody(products?.data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <div className="text-end">
        <div className="py-4">
          <ReactToPrint
            trigger={() => (
              <Button
                className="bg-white border rounded border-green-500 hover:border-green-900"
                type="button"
                size="large"
              >
                A4 Print <PrinterOutlined className="text-lg" />
              </Button>
            )}
            content={() => componentRef}
          />
        </div>
      </div>
      <Loadercomponent loader={loader}>
        <table
          className="w-full bg-white text-sm"
          ref={(el) => (componentRef = el)}
        >
          <thead className="text-gray-500">
            <tr>
              <td className="border p-2">Invoice</td>
              <td className="border p-2">Customer</td>
              <td className="border p-2">Branch</td>
              <td className="border p-2">Date</td>
              <td className="border p-2">Cash</td>
              <td className="border p-2">Debit</td>
              <td className="border p-2">Credit</td>
              <td className="border p-2">Bank</td>
              <td className="border p-2">Online</td>
              <td className="border p-2">Cheque</td>
              <td className="border p-2">Paid</td>
              <td className="border p-2">Payable</td>
              <td className="border p-2">Subtotal</td>
              <td className="border p-2">Tax&nbsp;[VAT]</td>
              <td className="border p-2">Total</td>
            </tr>
          </thead>
          <tbody>
            {body?.map((value, index) => {
              return (
                <tr>
                  <td className="border p-2 whitespace-nowrap">
                    #INV-{value?.number}
                  </td>
                  <td className="border p-2">{value?.customer?.name}</td>
                  <td className="border p-2">{value?.branch?.name}</td>
                  <td className="border p-2">
                    {value?.date
                      ? moment?.(value?.date)?.format?.("DD/MM/YYYY")
                      : ""}
                  </td>
                  <td className="border p-2">
                    {value?.total_cash?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.total_debit_card?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.total_credit_card?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.total_bank_transfer?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.total_online_payment?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.total_cheque?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.total_paid?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.total_payable?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.subtotal?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">
                    {value?.taxamount?.toFixed?.(3)}
                  </td>
                  <td className="border p-2">{value?.total?.toFixed?.(3)}</td>
                </tr>
              );
            })}
          </tbody>
          <tbody>
            <td className="border p-2 text-medium text-lg">TOTAL</td>
            <td className="border p-2"></td>
            <td className="border p-2"></td>
            <td className="border p-2"></td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total_cash),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) +
                    parseFloat(currentValue?.total_debit_card),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) +
                    parseFloat(currentValue?.total_credit_card),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) +
                    parseFloat(currentValue?.total_bank_transfer),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) +
                    parseFloat(currentValue?.total_online_payment),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total_cheque),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total_paid),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total_payable),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.subtotal),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.taxamount),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-2 text-medium text-lg">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total),
                  0
                )
                ?.toFixed(3)}
            </td>
          </tbody>
        </table>
      </Loadercomponent>
    </Header>
  );
};

export default SalesReportDashboard;
